import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, switchMap, takeUntil } from 'rxjs/operators';
import { ApiUrls, Doctypes } from 'src/app/shared/api-urls';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { combineLatest, forkJoin, merge } from 'rxjs';
import { SocketService } from 'src/app/shared/services/socket.service';

import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

class InvoicesFilter {
  search: any = {
    creation: '',
    status: 'All',
  };
  itemsPerPage = 20;
  currentPage = 1;
  totalCount = 0;
  start = 0;
}

@Component({
  selector: 'app-bulk-irn',
  templateUrl: './bulk-irn.component.html',
  styleUrls: ['./bulk-irn.component.scss'],
})
export class BulkIrnComponent implements OnInit {
  @ViewChild('pendingbulkirn', { static: true })
  pendingbulkirnTemplate: TemplateRef<any>;
  filters = new InvoicesFilter();
  onSearch = new EventEmitter();
  private destroyEvents: EventEmitter<boolean> = new EventEmitter();
  bulk_irn_data: any = [];
  bulkirntotaldata: any = [];
  today = moment(new Date()).format('YYYY-MM-DD');
  date_type = '';
  bulkirninvoice: any = [];
  constructor(
    private http: HttpClient,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public dateTimeAdapter: DateTimeAdapter<any>,
    private modal: NgbModal,
    private socketService: SocketService
  ) {
    dateTimeAdapter.setLocale('en-IN');
  }

  ngOnInit(): void {
    this.filters.start = 0;
    this.activatedRoute.queryParams.subscribe((params: any) => {
      if (Object.keys(params)?.length > 0) {
        this.filters = {
          ...params,
          search: JSON.parse(params?.search) || this.filters.search,
        };
      }
      console.log(this.filters, 'filters');
      this.getBulkIrnStatistics();
    });
    // merge(this.socketService.bulkIRN.pipe(takeUntil(this.destroyEvents)))
    //   .pipe(debounceTime(300))
    //   .subscribe((data) => {
    //     this.getBulkIrnStatistics();
    //     console.log(data);
    //   });
    // this.socketService.newInvoice.pipe(takeUntil(this.destroyEvents)).subscribe((res: any) => {
    // })
  }

  // ============================ GET BULK IRN DATA ============================

  getBulkIrnStatistics() {
    const queryParams: any = { filters: [] };
    queryParams.fields = JSON.stringify(['*']);
    if (this.filters.search.creation) {
      let fromdate = moment(this.filters.search.creation[0]).format(
        'YYYY-MM-DD'
      );
      let todate = moment(this.filters.search.creation[1]).format('YYYY-MM-DD');
      queryParams.filters.push(['creation', 'Between', [fromdate, todate]]);
    }

    queryParams.limit_page_length = this.filters.itemsPerPage;
    queryParams.limit_start =
      (this.filters.currentPage - 1) * this.filters.itemsPerPage;
    queryParams.fields = JSON.stringify(['*']);

    queryParams.filters = JSON.stringify(queryParams.filters);
    queryParams.order_by = "`tabBulk IRN Statistics`.`modified` desc"

    const countApi = this.http.get(
      ApiUrls.resource + '/' + Doctypes.Bulk_Irn_Statistics,
      {
        params: {
          fields: JSON.stringify([
            'count( `tabBulk IRN Statistics`.`name`) AS total_count',
          ]),
          filters: queryParams.filters,
          
        },
      }
    );

    const result = this.http.get(
      ApiUrls.resource + '/' + Doctypes.Bulk_Irn_Statistics,
      {
        params: queryParams,
      }
    );
    return forkJoin([countApi, result]).subscribe((res: any) => {
      const [count, data] = res;
      if (data.data) {
        this.filters.totalCount = count?.data[0]?.total_count;
        // if (this.filters.currentPage > 1) {
        //   this.bulk_irn_data = this.bulk_irn_data.concat(data?.data);
        //   return;
        // }
        // // if (data?.length != 0) {
        // this.bulk_irn_data = data?.data;
        // // }

        if (this.filters.currentPage != 1) {
          this.bulk_irn_data = this.bulk_irn_data.concat(data.data);
        } else {
          this.bulk_irn_data = data.data;
        }
      }
    });
  }

  convertToNumber(value: any) {
    return Number(value);
  }

  // ========================= UPDATE ROUTER PARAMS =========================

  updateRouterParams() {
    console.log('/////////////////////');
    const temp = JSON.parse(JSON.stringify(this.filters));
    temp.search = JSON.stringify(temp.search);
    this.router.navigate(['home/bulk-irn'], {
      queryParams: temp,
    });
  }

  // ========================= CLEAR CREATION DATE =========================

  clearcreationdate() {
    this.filters.search.creation = '';
    this.updateRouterParams();
  }

  checkPagination(): void {
    this.filters.currentPage = 1;
    this.updateRouterParams();
  }

  // ========================= SHOWPENDING COUNT =========================

  showpendingcount(bulk_irn_data: any) {
    this.bulkirntotaldata = JSON.parse(bulk_irn_data?.selected_invoices);
    let modalRef = this.modal.open(this.pendingbulkirnTemplate, {
      size: 'md',
      centered: true,
      windowClass: 'bulkirnsideMenu',
    });
  }

  bulkirnclose() {
    this.filters.search.status = 'All';
  }
  ngOnDestroy() {
    this.destroyEvents.next();
    this.destroyEvents.unsubscribe();
    // this.router.navigate([], {
    //   queryParams: {
    //     filters: '',
    //   },
    //   queryParamsHandling: 'merge',
    // });
  }
}
